import { Autocomplete, TextField } from "@mui/material";
import React from "react";
import { getGeneralLeague as fetchGeneralLeague } from "../../services/leagueService";
import { palette } from "../../styles/palette";
import "./styles.scss";

export type LeagueDescription = {
  leagueId: number;
  label: string;
};

export const getGeneralLeague = fetchGeneralLeague;

export const initLeagueDescription: LeagueDescription = {
  label: "General",
  leagueId: 2,
};

export interface LeaguesDropdownProps {
  setCurrentLeague: (league: LeagueDescription) => void;
  styles?: React.CSSProperties;
  leagueOptions: { label: string; leagueId: number }[];
  width?: string;
  currentLeague?: string;
}

const LeaguesDropdown: React.FC<LeaguesDropdownProps> = ({
  setCurrentLeague,
  styles,
  leagueOptions,
  width,
  currentLeague,
}) => {
  const selectedOption =
    leagueOptions.find((option) => option.label === currentLeague) ?? undefined;

  return (
    <Autocomplete
      value={selectedOption}
      onChange={(
        event: React.SyntheticEvent,
        newValue: { label: string; leagueId: number } | null
      ) =>
        newValue &&
        setCurrentLeague({
          label: newValue.label,
          leagueId: newValue.leagueId,
        })
      }
      onInputChange={(event) => {
        if (event?.type === "change") {
          event.preventDefault();
        }
      }}
      disablePortal
      autoHighlight
      clearOnEscape={false}
      clearOnBlur={false}
      disableClearable
      id="league-panel-search"
      options={leagueOptions}
      size="small"
      isOptionEqualToValue={(option, value) => option.leagueId === value.leagueId}
      getOptionLabel={(option) => option.label}
      sx={{ width: width ? width : "75%", color: palette.textPrimary }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={currentLeague}
          className="inputAutocompLeague leaguesDropdown__input"
          inputProps={{
            ...params.inputProps,
            readOnly: true,
          }}
        />
      )}
      style={styles}
    />
  );
};

export default LeaguesDropdown;
